import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X, ChevronRight, ChevronLeft, Star, Volume2, VolumeX, ExternalLink } from "lucide-react";
import { getButtonIcon } from "../lib/buttonIcons";
import DOMPurify from "dompurify";

export const MAIN_HERO_DEFAULTS = {
  enabled: false,
  max_width: 1080,
  align: "left", // block alignment: left | center | right
  // main hero image (shown to the right of the text, above the buttons band)
  main_img: "", main_img_en: "", main_img_show: true, main_img_w: 380, main_img_x: 0, main_img_y: 0,
  // top label
  top_show: true, top_pt: "BEM-VINDO AO", top_en: "WELCOME TO", top_font: "nunito", top_size: 16,
  top_color: "#C8A24B", top_effect: "none", top_align: "left", top_x: 0, top_y: 0, top_lh: 1.2,
  // main title line 1
  l1_show: true, l1_pt: "NATALMÁTICO", l1_en: "X-MATHS", l1_font: "anton", l1_size: 56,
  l1_color: "#1B5E3A", l1_effect: "none", l1_align: "left", l1_x: 0, l1_y: 0, l1_lh: 1.05,
  l1_colors_pt: [], l1_colors_en: [],
  // main title line 2
  l2_show: true, l2_pt: "CONCURSO 2025", l2_en: "CHALLENGE 2025", l2_font: "anton", l2_size: 48,
  l2_color: "#C1121F", l2_effect: "none", l2_align: "left", l2_x: 0, l2_y: 0, l2_lh: 1.05,
  l2_colors_pt: ["#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "", "#C8A24B", "#C8A24B", "#C8A24B", "#C8A24B"],
  l2_colors_en: ["#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "#C1121F", "", "#C8A24B", "#C8A24B", "#C8A24B", "#C8A24B"],
  // main title line 3
  l3_show: true, l3_pt: "", l3_en: "", l3_font: "anton", l3_size: 48,
  l3_color: "#C8A24B", l3_effect: "none", l3_align: "left", l3_x: 0, l3_y: 0, l3_lh: 1.05,
  l3_colors_pt: [], l3_colors_en: [],
  // paragraph
  txt_show: true,
  txt_pt: "O concurso que transforma a Matemática numa aventura divertida e desafiante! Participa com a tua turma e mostra o que vales.",
  txt_en: "The contest that turns Maths into a fun and challenging adventure! Join with your class and show what you've got.",
  txt_font: "nunito", txt_size: 18, txt_color: "#0B1D3A", txt_effect: "none", txt_align: "left", txt_x: 0, txt_y: 0, txt_lh: 1.5,
  // button 1
  b1_show: true, b1_pt: "VOU PARTICIPAR", b1_en: "I'LL JOIN", b1_sub_pt: "", b1_sub_en: "", b1_font: "outfit", b1_size: 16,
  b1_color: "#FFFFFF", b1_bg: "#1B5E3A", b1_shape: "rounded", b1_icon: "users", b1_effect: "none",
  b1_x: 0, b1_y: 0, b1_action: "route", b1_route: "/compete", b1_link: "", b1_popup_pt: "", b1_popup_en: "", b1_video: "",
  // button 2
  b2_show: true, b2_pt: "SAIBA COMO FUNCIONA", b2_en: "HOW IT WORKS", b2_sub_pt: "", b2_sub_en: "", b2_font: "outfit", b2_size: 16,
  b2_color: "#0B1D3A", b2_bg: "#FFFFFF", b2_shape: "rounded", b2_icon: "play", b2_effect: "none",
  b2_x: 0, b2_y: 0, b2_action: "route", b2_route: "/rules", b2_link: "", b2_popup_pt: "", b2_popup_en: "", b2_video: "",
  // buttons band (below hero): two side images + grid of buttons (configurable columns, unlimited buttons)
  band_show: false,
  btn_columns: 3,
  band_gap: 32,
  buttons: [],
  left_img: "", left_img_show: true, left_img_w: 150, left_img_x: 0, left_img_y: 0,
  right_img: "", right_img_show: true, right_img_w: 150, right_img_x: 0, right_img_y: 0,
  // about section (split block below the band): left text + right cards
  about_show: false,
  about_bg: "#EEF5EE", about_max_width: 1180, about_gap: 40,
  about_label_pt: "SOBRE O CONCURSO", about_label_en: "ABOUT THE CONTEST", about_label_star: true,
  about_label_color: "#C8A24B", about_label_font: "outfit",
  about_title_pt: "Aprender, praticar\ne divertir!", about_title_en: "Learn, practice\nand have fun!",
  about_title_color: "#1B5E3A", about_title_font: "anton", about_title_size: 44, about_title_lh: 1.05,
  about_text_pt: "O Natalmático é uma iniciativa que incentiva o gosto pela Matemática através de desafios criativos e estimulantes, promovendo o trabalho em equipa e o raciocínio lógico.",
  about_text_en: "Natalmático is an initiative that encourages a love for Maths through creative and stimulating challenges, promoting teamwork and logical reasoning.",
  about_text_color: "#0B1D3A", about_text_font: "nunito", about_text_size: 17, about_text_align: "left", about_text_lh: 1.65,
  about_align: "left",
  about_btn_show: true, about_btn_pt: "SAIBA MAIS", about_btn_en: "LEARN MORE",
  about_btn_bg: "#1B5E3A", about_btn_color: "#FFFFFF", about_btn_font: "outfit",
  about_btn_action: "route", about_btn_route: "/rules", about_btn_link: "", about_btn_popup_pt: "", about_btn_popup_en: "", about_btn_video: "",
  about_cols: 4,
  about_card_title_color: "#0B1D3A", about_card_text_color: "#0B1D3A", about_card_accent: "#1B5E3A", about_card_bg: "#FFFFFF",
  about_cards: [
    { id: "ac1", show: true, img: "", title_pt: "DESAFIOS DIVERTIDOS", title_en: "FUN CHALLENGES", desc_pt: "Problemas e atividades para todas as idades.", desc_en: "Problems and activities for all ages." },
    { id: "ac2", show: true, img: "", title_pt: "APRENDIZAGEM ATIVA", title_en: "ACTIVE LEARNING", desc_pt: "Matemática aplicada ao dia a dia.", desc_en: "Maths applied to everyday life." },
    { id: "ac3", show: true, img: "", title_pt: "TRABALHO EM EQUIPA", title_en: "TEAMWORK", desc_pt: "Turmas unidas para alcançar mais.", desc_en: "Classes united to achieve more." },
    { id: "ac4", show: true, img: "", title_pt: "PRÉMIOS E RECONHECIMENTO", title_en: "PRIZES & RECOGNITION", desc_pt: "Celebra o esforço e o talento de todos.", desc_en: "Celebrating everyone's effort and talent." },
  ],
  // info strip (green horizontal band below the about section)
  strip_show: false,
  strip_bg: "#1B5E3A", strip_max_width: 1180, strip_gap: 32, strip_radius: 24,
  strip_icon_color: "#C8A24B", strip_title_color: "#C8A24B", strip_title_font: "outfit", strip_text_color: "#FFFFFF",
  strip_cols: 3,
  strip_cta_show: true, strip_cta_action: "route", strip_cta_route: "/enroll", strip_cta_link: "", strip_cta_popup_pt: "", strip_cta_popup_en: "", strip_cta_video: "",
  strip_items: [
    { id: "si1", show: true, icon: "calendar", title_pt: "INSCRIÇÕES ABERTAS", title_en: "REGISTRATIONS OPEN", sub_pt: "De 1 a 15 de dezembro", sub_en: "From December 1-15" },
    { id: "si2", show: true, icon: "trophy", title_pt: "PARTICIPA E GANHA", title_en: "JOIN AND WIN", sub_pt: "Prémios para turmas vencedoras", sub_en: "Prizes for winning classes" },
    { id: "si3", show: true, icon: "info", title_pt: "DÚVIDAS?", title_en: "QUESTIONS?", sub_pt: "Consulta a nossa secção de perguntas frequentes", sub_en: "Check our FAQ section" },
  ],
};

const SHAPES = { pill: "999px", rounded: "16px", rect: "6px" };
const fxClass = (e) => (e && e !== "none" ? `promo-card-fx-${e}` : "");
const translate = (x, y) => `translate(${Number(x) || 0}px, ${Number(y) || 0}px)`;
const flexAlign = (a) => (a === "center" ? "center" : a === "right" ? "flex-end" : "flex-start");

function parseVideo(raw) {
  const url = (raw || "").trim();
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: "youtube", id: yt[1], url };
  if (/facebook\.com|fb\.watch/i.test(url)) return { type: "facebook", url };
  return { type: "file", url };
}

function embedSrc(v, muted) {
  if (v.type === "youtube")
    return `https://www.youtube.com/embed/${v.id}?autoplay=1&mute=${muted ? 1 : 0}&loop=1&playlist=${v.id}&controls=1&modestbranding=1&playsinline=1&rel=0`;
  if (v.type === "facebook")
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(v.url)}&show_text=false&autoplay=true&mute=${muted ? 1 : 0}`;
  return null;
}

function VideoCarousel({ videos }) {
  const list = (videos || []).map(parseVideo).filter(Boolean);
  const [i, setI] = useState(0);
  const [muted, setMuted] = useState(true);
  const n = list.length;
  useEffect(() => {
    if (n <= 1) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), 30000);
    return () => clearInterval(t);
  }, [n]);
  if (n === 0) return null;
  const idx = i % n;
  const v = list[idx];
  const platform = v.type === "youtube" ? "YouTube" : v.type === "facebook" ? "Facebook" : "vídeo";
  return (
    <div data-testid="popup-video-carousel">
      <div className="relative w-full rounded-xl overflow-hidden bg-black" style={{ paddingTop: "56.25%" }}>
        {v.type === "file" ? (
          <video key={`${idx}-${muted}`} src={v.url} autoPlay muted={muted} loop controls playsInline
            className="absolute inset-0 w-full h-full object-contain bg-black" />
        ) : (
          <iframe key={`${idx}-${muted}`} title={`video-${idx}`} src={embedSrc(v, muted)}
            className="absolute inset-0 w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        )}
        {n > 1 && (
          <>
            <button type="button" onClick={() => setI((x) => (x - 1 + n) % n)} data-testid="popup-video-prev"
              className="absolute left-2 top-1/2 -translate-y-1/2 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/45 text-white hover:bg-black/70">
              <ChevronLeft size={20} />
            </button>
            <button type="button" onClick={() => setI((x) => (x + 1) % n)} data-testid="popup-video-next"
              className="absolute right-2 top-1/2 -translate-y-1/2 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/45 text-white hover:bg-black/70">
              <ChevronRight size={20} />
            </button>
          </>
        )}
      </div>
      <div className="mt-3 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => setMuted((m) => !m)} data-testid="popup-video-sound"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0B1D3A]/5 hover:bg-[#0B1D3A]/10 text-[#0B1D3A] text-sm font-bold transition-colors">
            {muted ? <VolumeX size={16} /> : <Volume2 size={16} />} {muted ? "Ativar som" : "Silenciar"}
          </button>
          <a href={v.url} target="_blank" rel="noreferrer" data-testid="popup-video-link"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0B1D3A]/5 hover:bg-[#7C3AED] hover:text-white text-[#0B1D3A] text-sm font-bold transition-colors">
            <ExternalLink size={15} /> Ver no {platform}
          </a>
        </div>
        {n > 1 && (
          <div className="flex items-center gap-1.5" data-testid="popup-video-dots">
            {list.map((_, k) => (
              <button key={k} type="button" onClick={() => setI(k)} aria-label={`Vídeo ${k + 1}`}
                className={`h-2.5 rounded-full transition-all ${k === idx ? "w-6 bg-[#0B1D3A]" : "w-2.5 bg-[#0B1D3A]/25 hover:bg-[#0B1D3A]/50"}`} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function MainHero({ config, lang = "pt", preview = false, backendUrl = "", countdown = null, countdownPos = "" }) {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(null);
  const [headerH, setHeaderH] = useState(0);
  const popupScrollRef = useRef(null);
  useEffect(() => {
    if (popup) {
      if (popupScrollRef.current) popupScrollRef.current.scrollTop = 0;
      const h = document.querySelector('[data-testid="site-header-wrap"]')?.offsetHeight || 0;
      setHeaderH(h);
    }
  }, [popup]);
  const c = { ...MAIN_HERO_DEFAULTS, ...(config || {}) };
  if (!preview && c.enabled === false) return null;

  const cdAt = (slot) => (countdown && countdownPos === slot
    ? <div className="flex justify-center my-5" data-testid={`mh-cd-${slot}`}>{countdown}</div>
    : null);

  const tx = (pt, en) => (lang === "en" ? (en || pt) : pt);
  const fileUrl = (p) => (p ? `${backendUrl}/api/files/${p}` : null);
  const mainImg = (lang === "en" && c.main_img_en) ? c.main_img_en : c.main_img;

  const runAction = (action, route, link, popupTitle, popupContent, videos) => {
    if (preview) return;
    if (action === "route" && route) navigate(route);
    else if (action === "link" && link) window.open(link, /^https?:\/\//.test(link) ? "_blank" : "_self", "noopener");
    else if (action === "popup") setPopup({ title: popupTitle, content: popupContent, videos: (videos || []).filter(Boolean) });
  };

  const TextEl = ({ p, tag: Tag = "div", extra = "" }) => {
    if (c[`${p}_show`] === false) return null;
    const text = tx(c[`${p}_pt`], c[`${p}_en`]);
    if (!text) return null;
    const starMatch = text.match(/^\s*[⭐★☆🌟✦✧]\s*/);
    const body = starMatch ? text.slice(starMatch[0].length) : text;
    const letterColors = (p === "l1" || p === "l2" || p === "l3") ? (c[`${p}_colors_${lang}`] || []) : null;
    const inner = (letterColors && letterColors.length)
      ? [...body].map((ch, i) => <span key={i} style={{ color: letterColors[i] || c[`${p}_color`] }}>{ch}</span>)
      : body;
    const content = starMatch
      ? (<>
          <Star size={Math.round(Number(c[`${p}_size`]) * 0.82)} fill="currentColor" stroke="none" className="inline-block align-[-0.12em] mr-2" />
          {inner}
        </>)
      : inner;
    const sz = Number(c[`${p}_size`]) || 16;
    const isTitle = (p === "l1" || p === "l2" || p === "l3");
    const fontSize = isTitle
      ? `clamp(${Math.round(sz * 0.42)}px, ${(sz / 13).toFixed(2)}vw, ${sz}px)`
      : `${sz}px`;
    return (
      <Tag
        data-testid={`main-hero-${p}`}
        className={`font-${c[`${p}_font`]} ${fxClass(c[`${p}_effect`])} ${extra}`}
        style={{ color: c[`${p}_color`], fontSize, textAlign: c[`${p}_align`], transform: translate(c[`${p}_x`], c[`${p}_y`]), width: "100%", lineHeight: c[`${p}_lh`] ?? 1.15 }}
      >
        {content}
      </Tag>
    );
  };

  const onBtn = (p) => {
    runAction(c[`${p}_action`], c[`${p}_route`], c[`${p}_link`], tx(c[`${p}_pt`], c[`${p}_en`]), tx(c[`${p}_popup_pt`], c[`${p}_popup_en`]), [c[`${p}_video`]]);
  };

  const Btn = ({ p }) => {
    if (c[`${p}_show`] === false) return null;
    const label = tx(c[`${p}_pt`], c[`${p}_en`]);
    if (!label) return null;
    const Icon = c[`${p}_icon`] ? getButtonIcon(c[`${p}_icon`], null) : null;
    const sub = tx(c[`${p}_sub_pt`], c[`${p}_sub_en`]);
    return (
      <button
        type="button" onClick={() => onBtn(p)} data-testid={`main-hero-${p}-btn`}
        className={`mh-hero-btn inline-flex items-center justify-center gap-2.5 font-${c[`${p}_font`]} font-bold transition-transform hover:-translate-y-0.5 ${fxClass(c[`${p}_effect`])}`}
        style={{ background: c[`${p}_bg`], color: c[`${p}_color`], borderRadius: SHAPES[c[`${p}_shape`]] || SHAPES.rounded, fontSize: `${c[`${p}_size`]}px`, padding: "13px 24px", boxShadow: "0 8px 18px rgba(0,0,0,0.18)", border: "1px solid rgba(11,29,58,0.08)", transform: translate(c[`${p}_x`], c[`${p}_y`]) }}
      >
        {Icon && <Icon size={Number(c[`${p}_size`]) + 4} strokeWidth={2.4} />}
        <span className="inline-flex flex-col items-start leading-tight text-left">
          <span>{label}</span>
          {sub && <span className="font-medium opacity-80" style={{ fontSize: `${Math.max(10, Math.round(Number(c[`${p}_size`]) * 0.72))}px` }}>{sub}</span>}
        </span>
      </button>
    );
  };

  const blockMargin = c.align === "center" ? "0 auto" : c.align === "right" ? "0 0 0 auto" : "0 auto 0 0";

  const SideImg = ({ side }) => {
    if (c[`${side}_img_show`] === false || !c[`${side}_img`]) return null;
    return (
      <img src={fileUrl(c[`${side}_img`])} alt="" data-testid={`main-hero-${side}-img`}
        className="shrink-0 object-contain self-center pointer-events-none select-none"
        style={{ width: `${c[`${side}_img_w`]}px`, transform: translate(c[`${side}_img_x`], c[`${side}_img_y`]) }} />
    );
  };

  const BtnCard = (b, i) => {
    if (b.show === false) return null;
    const label = tx(b.label_pt, b.label_en);
    const sub = tx(b.sub_pt, b.sub_en);
    const Icon = b.icon ? getButtonIcon(b.icon, null) : null;
    const sz = Number(b.size) || 15;
    return (
      <button key={b.id || i} type="button" data-testid={`main-hero-band-btn-${i}`}
        onClick={() => runAction(b.action, b.route, b.link, label, tx(b.popup_pt, b.popup_en), (b.videos && b.videos.length ? b.videos : [b.video]))}
        className="mh-band-btn-el group flex items-center gap-3 rounded-2xl px-5 py-4 text-left shadow-[0_8px_20px_-6px_rgba(11,29,58,0.25)] transition-transform hover:-translate-y-0.5"
        style={{ background: b.bg || "#6366F1", color: b.color || "#FFFFFF", transform: translate(b.pos_x, b.pos_y) }}>
        {Icon && (
          <span className="inline-flex items-center justify-center rounded-xl shrink-0" style={{ background: "rgba(255,255,255,0.18)", height: `${Math.round(sz * 2.4)}px`, width: `${Math.round(sz * 2.4)}px` }}>
            <Icon size={Math.round(sz * 1.35)} strokeWidth={2.2} />
          </span>
        )}
        <span className="flex-1 min-w-0">
          <span className="block font-outfit font-bold leading-tight uppercase tracking-wide" style={{ fontSize: `${sz}px` }}>{label}</span>
          {sub && <span className="block opacity-80 truncate" style={{ fontSize: `${Math.max(10, Math.round(sz * 0.72))}px` }}>{sub}</span>}
        </span>
        <ChevronRight size={18} className="opacity-70 group-hover:translate-x-0.5 transition-transform" />
      </button>
    );
  };

  const cols = Math.min(4, Math.max(1, Number(c.btn_columns) || 3));
  const bandJustify = c.band_align === "left" ? "md:justify-start" : c.band_align === "right" ? "md:justify-end" : "md:justify-center";
  const Band = () => (
    <div className={`w-full flex flex-col md:flex-row items-center md:items-stretch justify-center ${bandJustify} gap-4 md:gap-6`}
      style={{ marginTop: `${c.band_gap ?? 32}px`, transform: translate(c.band_offset_x, c.band_offset_y) }} data-testid="main-hero-band">
      <SideImg side="left" />
      <div className="mh-band-grid w-full flex-1 grid gap-3 md:gap-4 content-center" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
        {(c.buttons || []).map((b, i) => BtnCard(b, i))}
      </div>
      <SideImg side="right" />
    </div>
  );

  const aboutCols = Math.min(4, Math.max(1, Number(c.about_cols) || 4));
  const AboutCard = (card, i) => {
    if (card.show === false) return null;
    const title = tx(card.title_pt, card.title_en);
    const desc = tx(card.desc_pt, card.desc_en);
    return (
      <div key={card.id || i} data-testid={`main-hero-about-card-${i}`}
        className="flex flex-col items-center text-center rounded-2xl px-4 py-6 shadow-[0_10px_30px_-12px_rgba(11,29,58,0.25)]"
        style={{ background: c.about_card_bg || "#FFFFFF" }}>
        <div className="h-36 flex items-center justify-center mb-4">
          {card.img
            ? <img src={fileUrl(card.img)} alt="" className="max-h-36 max-w-full object-contain" data-testid={`main-hero-about-card-img-${i}`} />
            : <div className="h-28 w-28 rounded-2xl border-2 border-dashed border-[#0B1D3A]/15 text-[#0B1D3A]/35 flex items-center justify-center text-[10px] font-semibold text-center p-2">Imagem</div>}
        </div>
        <h3 className="font-outfit font-extrabold uppercase tracking-wide text-[15px] leading-tight mb-3" style={{ color: c.about_card_title_color }}>{title}</h3>
        <p className="font-nunito text-sm leading-relaxed flex-1" style={{ color: c.about_card_text_color, opacity: 0.85 }}>{desc}</p>
        <span className="mt-4 h-1.5 w-10 rounded-full" style={{ background: c.about_card_accent }} />
      </div>
    );
  };

  const onAboutBtn = () => runAction(c.about_btn_action, c.about_btn_route, c.about_btn_link, tx(c.about_btn_pt, c.about_btn_en), tx(c.about_btn_popup_pt, c.about_btn_popup_en), [c.about_btn_video]);
  const aboutLabel = tx(c.about_label_pt, c.about_label_en);
  const aboutTitle = tx(c.about_title_pt, c.about_title_en);
  const aboutText = tx(c.about_text_pt, c.about_text_en);
  const aboutBtn = tx(c.about_btn_pt, c.about_btn_en);
  const About = () => (
    <div className="w-full" style={{ marginTop: `${c.about_gap ?? 40}px` }} data-testid="main-hero-about">
      <div className="rounded-[28px] px-6 py-8 sm:px-10 sm:py-12" style={{ background: c.about_bg, maxWidth: `${c.about_max_width}px`, margin: "0 auto" }}>
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.6fr)] gap-8 lg:gap-12 items-center">
          {/* Left text column */}
          <div className="flex flex-col" style={{ alignItems: flexAlign(c.about_align), textAlign: c.about_align }}>
            {aboutLabel && (
              <span className="inline-flex items-center gap-2 font-bold uppercase tracking-wider text-sm mb-4" style={{ color: c.about_label_color }} data-testid="main-hero-about-label">
                {c.about_label_star && <Star size={16} fill="currentColor" stroke="none" />}{aboutLabel}
              </span>
            )}
            <h2 className={`font-${c.about_title_font} font-extrabold whitespace-pre-line mb-5`} style={{ color: c.about_title_color, fontSize: `${c.about_title_size}px`, lineHeight: c.about_title_lh ?? 1.05 }} data-testid="main-hero-about-title">{aboutTitle}</h2>
            {aboutText && <p className={`font-${c.about_text_font} mb-6`} style={{ color: c.about_text_color, fontSize: `${c.about_text_size}px`, lineHeight: c.about_text_lh ?? 1.65, opacity: 0.9, textAlign: c.about_text_align || c.about_align }} data-testid="main-hero-about-text">{aboutText}</p>}
            {c.about_btn_show !== false && aboutBtn && (
              <button type="button" onClick={onAboutBtn} data-testid="main-hero-about-btn"
                className={`inline-flex items-center gap-2 font-${c.about_btn_font} font-bold uppercase tracking-wide rounded-2xl px-7 py-3.5 text-sm shadow-[0_10px_24px_-8px_rgba(11,29,58,0.4)] transition-transform hover:-translate-y-0.5`}
                style={{ background: c.about_btn_bg, color: c.about_btn_color }}>
                {aboutBtn} <ChevronRight size={18} />
              </button>
            )}
          </div>
          {/* Right cards grid */}
          <div className="mh-about-grid grid gap-4 md:gap-5" style={{ gridTemplateColumns: `repeat(${aboutCols}, minmax(0, 1fr))` }} data-testid="main-hero-about-cards">
            {(c.about_cards || []).map((card, i) => AboutCard(card, i))}
          </div>
        </div>
      </div>
    </div>
  );

  const stripCols = Math.min(4, Math.max(1, Number(c.strip_cols) || 3));
  const onStripCta = () => runAction(c.strip_cta_action, c.strip_cta_route, c.strip_cta_link, "", tx(c.strip_cta_popup_pt, c.strip_cta_popup_en), [c.strip_cta_video]);
  const StripItem = (it, i) => {
    if (it.show === false) return null;
    const title = tx(it.title_pt, it.title_en);
    const sub = tx(it.sub_pt, it.sub_en);
    const Icon = it.icon ? getButtonIcon(it.icon, null) : null;
    return (
      <div key={it.id || i} className="flex items-center gap-4 px-2" data-testid={`main-hero-strip-item-${i}`}>
        {Icon && (
          <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2" style={{ borderColor: c.strip_icon_color, color: c.strip_icon_color }}>
            <Icon size={24} strokeWidth={2} />
          </span>
        )}
        <span className="flex flex-col min-w-0">
          <span className={`font-${c.strip_title_font} font-extrabold uppercase tracking-wide text-[15px] leading-tight`} style={{ color: c.strip_title_color }}>{title}</span>
          {sub && <span className="text-sm leading-snug mt-0.5" style={{ color: c.strip_text_color, opacity: 0.92 }}>{sub}</span>}
        </span>
      </div>
    );
  };
  const InfoStrip = () => (
    <div className="w-full" style={{ marginTop: `${c.strip_gap ?? 32}px` }} data-testid="main-hero-strip">
      <div className="px-6 py-7 sm:px-10 sm:py-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-5 sm:gap-6" style={{ background: c.strip_bg, maxWidth: `${c.strip_max_width}px`, margin: "0 auto", borderRadius: `${c.strip_radius ?? 24}px` }}>
        <div className="mh-strip-grid flex-1 grid gap-5 md:gap-2 items-center" style={{ gridTemplateColumns: `repeat(${stripCols}, minmax(0, 1fr))` }}>
          {(c.strip_items || []).map((it, i) => StripItem(it, i))}
        </div>
        {c.strip_cta_show !== false && (
          <button type="button" onClick={onStripCta} data-testid="main-hero-strip-cta"
            className="shrink-0 self-center inline-flex h-14 w-14 items-center justify-center rounded-full border-2 transition-transform hover:translate-x-0.5"
            style={{ borderColor: c.strip_icon_color, color: c.strip_icon_color }}>
            <ChevronRight size={26} strokeWidth={2.5} />
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      <div className="w-full" data-testid="main-hero" style={{ maxWidth: `${c.max_width}px`, margin: blockMargin }}>
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="flex flex-col gap-3 flex-1 min-w-0">
            <TextEl p="top" extra="font-bold uppercase tracking-wider" />
            <div className="flex flex-col gap-0.5">
              <TextEl p="l1" tag="h1" extra="font-extrabold tracking-tight" />
              <TextEl p="l2" tag="h2" extra="font-extrabold tracking-tight" />
              <TextEl p="l3" tag="h2" extra="font-extrabold tracking-tight" />
            </div>
            {cdAt("mh_below_title")}
            <TextEl p="txt" tag="p" extra="max-w-2xl" />
            {(c.b1_show !== false || c.b2_show !== false) && (
              <div className="mh-hero-btns flex flex-wrap gap-3 mt-2" style={{ justifyContent: flexAlign(c.align) }} data-testid="main-hero-buttons">
                <Btn p="b1" />
                <Btn p="b2" />
              </div>
            )}
            {cdAt("mh_below_buttons")}
          </div>
          {(c.main_img_show !== false && (mainImg || preview)) && (
            <div className="shrink-0 w-full lg:w-auto flex justify-center" data-testid="main-hero-image-wrap">
              {mainImg ? (
                <img src={fileUrl(mainImg)} alt="" data-testid="main-hero-image" className="mh-main-img-el object-contain max-w-full"
                  style={{ width: `${c.main_img_w}px`, transform: translate(c.main_img_x, c.main_img_y) }} />
              ) : (
                <div className="rounded-2xl border-2 border-dashed border-[#0B1D3A]/20 text-[#0B1D3A]/40 flex items-center justify-center text-xs font-semibold text-center p-4"
                  style={{ width: `${c.main_img_w}px`, height: `${Math.round(c.main_img_w * 0.7)}px` }}>
                  Imagem principal<br />(carregar no editor)
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {(preview || c.band_show) && <Band />}
      {cdAt("mh_below_band")}

      {cdAt("mh_above_about")}
      {(preview || c.about_show) && <About />}
      {cdAt("mh_below_about")}

      {(preview || c.strip_show) && <InfoStrip />}
      {cdAt("mh_below_strip")}

      {popup && (
        <div className="fixed left-0 right-0 bottom-0 z-50 flex items-start justify-center bg-[#0B1D3A]/60 backdrop-blur-sm px-4 py-5 overflow-y-auto" style={{ top: `${headerH}px` }} data-testid="main-hero-popup" onClick={() => setPopup(null)}>
          <div ref={popupScrollRef} className="bg-white rounded-3xl p-6 md:p-8 max-w-2xl w-full overflow-y-auto shadow-2xl relative" style={{ maxHeight: `calc(100vh - ${headerH}px - 2.5rem)` }} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setPopup(null)} data-testid="main-hero-popup-close" className="absolute top-4 right-4 inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#0B1D3A]/5 hover:bg-[#0B1D3A]/10 text-[#0B1D3A]"><X size={18} /></button>
            {popup.title && <h2 className="font-fredoka text-2xl font-bold text-[#0B1D3A] mb-4 pr-10">{popup.title}</h2>}
            {popup.videos && popup.videos.length > 0 && <VideoCarousel videos={popup.videos} />}
            {popup.content && (
              <div
                className={`font-nunito text-[#0B1D3A]/80 leading-relaxed text-left [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-blue-600 [&_a]:underline ${/<[a-z][\s\S]*>/i.test(popup.content) ? "" : "whitespace-pre-wrap"} ${popup.videos && popup.videos.length > 0 ? "mt-5" : ""}`}
                data-testid="popup-text"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(popup.content, {
                  ALLOWED_TAGS: ["b", "strong", "i", "em", "u", "s", "span", "font", "br", "p", "div", "ul", "ol", "li", "a", "h1", "h2", "h3"],
                  ALLOWED_ATTR: ["style", "href", "target", "rel", "color", "size", "class", "align"],
                }) }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
